<template>
    <div>
        <p v-if="loading">Loading channels...</p>
        <div v-else>
            <div v-if="nonconsentedChannels.length > 0">
                <div v-for="channel in nonconsentedChannels" :key="channel.id">
                    <dl v-if="channel.is_primary" class="row mb-2">
                        <dt class="col-sm-4">{{ channel.name }}</dt>
                        <dd v-if="channel.channel_type_id == 3" class="col-sm-8 mb-0"><!-- channel_type_id == 3 is 'Address' -->
                            <span v-html="formatMultilineAddress(channel.address)"></span>
                        </dd>
                        <dd v-else class="col-sm-8 mb-0">{{ channel.address }}</dd>
                    </dl>
                </div>
            </div>
            <p v-else>No channels found</p>
        </div>
        <div class="row mt-2">
            <div class="col d-flex justify-content-end">
                <button  v-if="!showManageChannelsButton" class="btn btn-primary btn-sm py-0 px-1" @click="openChannelsModal">Manage Channels</button>
            </div>
        </div>
        <channels-modal ref="channelsModal"></channels-modal>
    </div>
</template>


<script setup>
    import { ref, computed } from 'vue'
    import { storeToRefs } from 'pinia'
    import { useChannelsStore } from '../../stores/channels-store'
    import ChannelsModal from './ChannelsModal.vue'

    const { channels, loading, error, recipient } = storeToRefs(useChannelsStore())
    const { setRecipient, fetchChannels, fetchCommLogs } = useChannelsStore()
    const props = defineProps(['recipientType', 'recipientId', 'user']) 

    setRecipient(props.recipientType, props.recipientId)

    fetchChannels()
    fetchCommLogs()

    const nonconsentedChannels = computed(() => {
      return channels.value ? channels.value.filter(channel => channel.is_consented_type != 1) : [];
    })

    function formatMultilineAddress (address) {
        const _address = JSON.parse(address)
        const street1 = _address.street1 ? _address.street1 +'<br>' : ''
        const street2 = _address.street2 ? _address.street2 +'<br>' : ''
        const city = _address.city ? _address.city : ''
        const zipcode = _address.zipcode ? ', '+ _address.zipcode : ''
        return street1 + street2 + city + zipcode
    }

    // open modal to manage channels
    let channelsModal = ref(null);
    function openChannelsModal () {
        channelsModal.value.show()
    }

    const showManageChannelsButton = computed(() => {
    return (
        props.user &&
        props.user.roles &&
        props.user.roles.length > 0 &&
        props.user.roles[0].name === "Interview Team"
    );
    });
</script>